import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { UserService } from "../services/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AssetsService } from "../services/assets.service";
import { NotificationsService } from "angular2-notifications";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner"
import { PuserserviceService } from "../services/puserservice.service";
import { PagerserviceService } from "../services/pagerservice.service";
import { environment } from '../../environments/environment';
import { AdminService } from "../services/admin.service";
import * as XLSX from 'xlsx';
import { MatAutocompleteSelectedEvent, MatDatepickerInputEvent, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as moment from 'moment';

@Component({
    selector: 'app-ledger',
    templateUrl: './ledger.component.html',
    styleUrls: ['./ledger.component.css']
})
export class LedgerComponent implements OnInit {
    currencies: any[] = [];
    currencyListSearchCopy: any[] = [];
    ledger: Array<any>;
    FilPerpage: number;
    FilPage: number;
    pager: number;
    Tpager: number;
    UId: string;
    fileName: string;
    pager1: any = {};
    currencylist = [];
    clientActivation: Boolean;
    admindetails = {
        _id: ''
    };
    activitydetail = {
        ipaddress: '',
        status: '',
        _csrf: '',
        username: ''
    }
    // searchObj={
    //     time1:new Date(),
    //     time:new Date()
    // }
    permission: string;
    currentPag: any = 0;
    ledgerlist: Array<any> = [];
    displayedColumns = [
        'txnid',
        'type',
        'txnType',
        'currency',
        'amount',
        'note',
        'availableBalance',
        'username',
        'createdAt'
    ];
    fromDate;
    toDate;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    public ledgerDataSouuce: any = new MatTableDataSource();
    pageSize = 25;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(private router: Router, private userService: UserService,
        private assetService: AssetsService,
        private spinnerService: Ng4LoadingSpinnerService,
        private notifSer: NotificationsService,
        private pagerService: PagerserviceService,
        private pusherService: PuserserviceService, private route: ActivatedRoute,
        private adminService: AdminService,
    ) { }

    ngOnInit() {
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {
            this.admindetails = this.userService.getUserDetails();

            let id = this.route.snapshot.paramMap.get('id');
            if (typeof id !== 'undefined' && id) {
                this.UId = id;
                this.clientActivation = false;
            } else {
                this.UId = this.admindetails._id;
                this.clientActivation = true;
            }
            this.FilPerpage = 10;
            this.FilPage = 1;
            this.pager = 1;
            this.adminService.groupupdate.subscribe(permData => {
                localStorage.setItem('permission', permData.permission);
                this.permission = permData.permission
            });
            this.permission = this.adminService.getPermission();
            this.getCurrency();
            this.getLedger();
            this.csrf();
        }
        this.userService.getAllCurrency().subscribe(data => {
            this.currencies = data;
            this.currencyListSearchCopy = data;
        })
    }
    filterWithCurrency(event: any) {
        let term = event;
        this.currencies = this.currencyListSearchCopy.filter(function (tag) {
            if (tag.CurrencySymbol.toLowerCase().indexOf(term.toLowerCase()) >= 0 || tag.CurrencySymbol.toLowerCase().indexOf(term.toLowerCase()) >= 0) {
                return tag;
            }
        });
    }
    onOptionSelected(event: MatAutocompleteSelectedEvent) {
        this.filter['currency'] = event.option.value;
        if (event.option.value === '') this.filter['currency'] = null
    }
    csrf() {
        this.userService.csrf().subscribe((success) => {
            this.activitydetail._csrf = success._csrf;
            this.getUserLogs();
        }, (error) => {
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }
    applyRefreshData() {
        this.getLedger();
    }
    dateformat(value) {
        return new DatePipe('en-Us').transform(value, 'dd-MM-yyyy HH:mm:ss', 'GMT+2');
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.ledgerDataSouuce.filter = filterValue;
    }
    getLedger() {
        this.spinnerService.show();
        this.filter = {
            perpage: this.FilPerpage,
            page: this.FilPage,
            userid: this.UId,
            fDate: this.filter['fDate'],
            tDate: this.filter['tDate'],
            currency: this.filter['currency'],

        }
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data['_csrf'];
            console.log(this.filter)
            this.userService.getLedgerList(this.filter).subscribe(list => {
                if (list.status) {
                    this.ledger = list.ledger.map(v => ({ ...v, image: this.currencylist.find(e => e.code === v.currency) }));
                    const ledgerRes = this.ledger.map(ledger => {
                        if (ledger && ledger.userid && ledger.userid.name) {
                            ledger.username = ledger.userid.name;
                            return ledger;
                        }

                    })
                    this.ledgerDataSouuce = new MatTableDataSource(ledgerRes);
                    this.ledgerDataSouuce.paginator = this.paginator;
                    this.ledgerDataSouuce.sort = this.sort;
                    this.Tpager = list.pages;
                    this.currentPag = list.current
                    this.setPage(this.FilPage);
                    this.ledgerlist = []
                    this.ledger.forEach(element => {
                        this.ledgerlist.push({
                            'TxnId': element.txnid,
                            'Type': element.txnType,
                            'TxnType': element.type,
                            'Currency': element.currency,
                            'Amount': element.amount,
                            'Available Balance': element.availableBalance,
                            'Notes': element.note,
                            'Total balance': element.totalbalance,
                            'Date of Transaction': this.dateformat(element.createdAt),
                            'Status': element.status
                        })
                    });

                }
                this.spinnerService.hide();
            }, (err) => {
                this.spinnerService.hide();
                this.notifSer.error(
                    'Error ',
                    err.error.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            })
        })

    }

    /**
     * get all currency 
     */
    getCurrency() {
        this.userService.getAllCurrencies('').subscribe(list => {
            this.currencylist = list;
        })
    }
    setPage(page: number) {
        // get pager object from service
        this.pager1 = this.pagerService.getPager(this.Tpager, page);
    }

    setPageOnClick(page: number) {
        this.pager = page;
        this.FilPage = page;
        this.getLedger();
    }

    getLogsExp() {
        this.fileName = 'Ledger.xlsx'
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.ledgerlist);
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        XLSX.writeFile(wb, this.fileName);
    }
    getUserLogs() {
        this.getLedger();
    }
}



// WEBPACK FOOTER //
// ./src/app/ledger/ledger.component.ts